module.exports = __webpack_public_path__ + "static/media/6.f8b1cedc.png";